import { StateCreator } from 'zustand';

import {
  handleClearIntent,
  handleClearIntents,
  handleIsHiddenByIntent,
  handleIsLinkedByIntent,
  handlePruneExpiredIntents,
  handleReconcileCommunication,
  handleReconcileSnoozedIntents,
  handleSetLabelsIntent,
  handleSetLinkedToEntryIntent,
  handleSetSnoozedIntent,
  handleSettleIntent,
} from './handlers';
import { CommunicationIntentsStore } from './types';

export const createCommunicationIntentsSlice: StateCreator<
  CommunicationIntentsStore
> = (set, get) => {
  return {
    intents: {},
    setLabelsIntent: (params) => handleSetLabelsIntent(set, params),
    setSnoozedIntent: (params) => handleSetSnoozedIntent(set, params),
    setLinkedToEntryIntent: (params) =>
      handleSetLinkedToEntryIntent(set, params),
    clearIntent: (messageId) => handleClearIntent(set, messageId),
    clearIntents: (messageIds) => handleClearIntents(set, get, messageIds),
    settleIntent: (messageId) => handleSettleIntent(set, get, messageId),
    reconcileCommunication: (communication) =>
      handleReconcileCommunication(set, get, communication),
    reconcileSnoozedIntents: (snoozedMessageIds) =>
      handleReconcileSnoozedIntents(set, get, snoozedMessageIds),
    isHiddenByIntent: (messageId) => handleIsHiddenByIntent(get, messageId),
    isLinkedByIntent: (messageId) => handleIsLinkedByIntent(get, messageId),
    pruneExpiredIntents: () => handlePruneExpiredIntents(set, get),
    resetState: () => set({ intents: {} }),
  };
};
